import { render, staticRenderFns } from "./RegAfterKyc.vue?vue&type=template&id=6347a7a9&scoped=true"
import script from "./RegAfterKyc.vue?vue&type=script&lang=ts"
export * from "./RegAfterKyc.vue?vue&type=script&lang=ts"
import style0 from "./RegAfterKyc.vue?vue&type=style&index=0&id=6347a7a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6347a7a9",
  null
  
)

export default component.exports